import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import {AppContext, App} from './components';

declare global {
  interface HTTPOptions {
    fetchOptions: any;
  }
}

ReactDOM.render(
  <AppContext>
    <App />
  </AppContext>,
  document.getElementById('root'),
);
